import { LinkOutlined } from '@ant-design/icons'
import { useUploadProps } from '@crm/hooks/useUploadProps'

import { useLocales } from '@shared/locales'
import { Button, Form, Space, Upload } from 'antd'

import { TaskFormElement } from './types'

type Props = {
  element: TaskFormElement
  required?: boolean
}

export const UploadElement = ({ element, required }: Props) => {
  const uploadProps = useUploadProps()
  const { t } = useLocales()

  return (
    <Form.Item
      name={element.name}
      label={element.label}
      normalize={(value) => ({ file: value?.file?.response?.url })}
      rules={[{ required }]}
    >
      <Upload {...uploadProps} data={{ public: false }} type="drag">
        <Space direction="vertical" align="center">
          <Upload />
          {t('drop_zone.drag_drop')}
          {t('drop_zone.or')}
          <Button icon={<LinkOutlined />}>{t('drop_zone.browse_file')}</Button>
        </Space>
      </Upload>
    </Form.Item>
  )
}
